import { VPagination } from 'vuetify/lib/components/VPagination';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VPagination,_vm._g(_vm._b({staticClass:"pagination",attrs:{"prev-icon":"$app-angle-left","next-icon":"$app-angle-right"},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}},'v-pagination',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }